import LayoutWithSideMenu from '@/layout/layoutWithSideMenu/index.vue'

export const inv = {
  path: '/inv/',
  name: 'inv',
  component: LayoutWithSideMenu,
  meta: {
    title: '物资管理'
  },
  children: [{
    path: 'itemWare',
    name: 'itemWare',
    component: () => import('@/views/inv/itemWare/index.vue'),
    meta: {
      title: '驻点库位'
    }
  }, {
    path: 'itemWareHouse',
    name: 'itemWareHouse',
    component: () => import('@/views/inv/itemWareHouse/index.vue'),
    meta: {
      title: '仓库信息'
    }
  }, {
    path: 'itemWareShelve',
    name: 'itemWareShelve',
    component: () => import('@/views/inv/itemWareShelve/index.vue'),
    meta: {
      title: '货架信息'
    }
  }, {
    path: 'manageMaterialToolApply',
    name: 'manageMaterialToolApply',
    component: () => import('@/views/inv/manageMaterialToolApply/index.vue'),
    meta: {
      title: '物料工具申领'
    }
  }, {
    path: 'stayPointStorage',
    name: 'stayPointStorage',
    component: () => import('@/views/inv/stayPointStorage/index.vue'),
    meta: {
      title: '驻点入库'
    }
  }, {
    path: 'officeMaterialToolDelivery',
    name: 'officeMaterialToolDelivery',
    component: () => import('@/views/inv/officeMaterialToolDelivery/index.vue'),
    meta: {
      title: '售后发料'
    }
  }, {
    path: 'manageStorageWarning',
    name: 'manageStorageWarning',
    component: () => import('@/views/inv/manageStorageWarning/index.vue'),
    meta: {
      title: '库存预警'
    }
  }, {
    path: 'toolsUse',
    name: 'toolsUse',
    component: () => import('@/views/inv/toolsUse/index.vue'),
    meta: {
      title: '工具领用'
    }
  }, {
    path: 'stayPointConsumingInfo',
    name: 'stayPointConsumingInfo',
    component: () => import('@/views/inv/stayPointConsumingInfo/index.vue'),
    meta: {
      title: '物料领用'
    }
  }, {
    path: 'stayPointReturn',
    name: 'stayPointReturn',
    component: () => import('@/views/inv/stayPointReturn/index.vue'),
    meta: {
      title: '物料退库'
    }
  }, {
    path: 'toolsLose',
    name: 'toolsLose',
    component: () => import('@/views/inv/toolsLose/index.vue'),
    meta: {
      title: '工具丢失'
    }
  }, {
    path: 'manageTransfer',
    name: 'manageTransfer',
    component: () => import('@/views/inv/manageTransfer/index.vue'),
    meta: {
      title: '工具/物料调拨'
    }
  }, {
    path: 'approval/info',
    name: 'approvalInfo',
    component: () => import('@/views/inv/manageMaterialToolApply/approval/approvalForm.vue'),
    meta: {
      title: '流程审批'
    }
  }, {
    path: 'manageTransfer/approval',
    name: 'dbApproval',
    component: () => import('@/views/inv/manageTransfer/approval/approval.vue'),
    meta: {
      title: '调拨流程审批'
    }
  }, {
    path: 'wms',
    name: 'wms',
    component: () => import('@/views/inv/wms/index.vue'),
    meta: {
      title: 'WMS领料'
    }
  }

  ]
}
